module.exports = __webpack_public_path__ + "static/097_stacja_anagl-9b2121344bd33e8909a64574dc4e5def.jpg";